import React, { useContext, useEffect, useState } from 'react';
import { ListGroup, Dropdown } from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';
import { ConfigContext } from '../../../../contexts/ConfigContext';

import avatar1 from '../../../../assets/images/user/usernew1.png';
import axios from 'axios';

const NavRight = ({ dropdownVisible, handleImageClick }) => {
  const configContext = useContext(ConfigContext);
  const navigate = useNavigate();
  const isWidth = window.innerWidth > 990;
  const { rtlLayout } = configContext.state;
  const [image,setimg]=useState('')
  const [membername, setMemberName] = useState('');
  const [memberType, setMemberType] = useState('');
  const [member, setMember] = useState({
    name: '',
    type: ''
  });
  const { name, type } = member;
  const [memeberId,setMemberId]=useState('')
  const [userType,setUserType]=useState('')


  const { dispatch , state} = configContext;

  useEffect(() => {
    const token = localStorage.getItem('token');
    const memberId = localStorage.getItem('memberId');
    setMemberId(memberId);
    
    const userType = localStorage.getItem('usertype');
    setUserType(userType);
    if(userType==="Member"){
      //console.log('hello')
      getProfileimg(token,memberId)
    }
    // else{
    //   console.log('Admin')
    //   setimg(avatar1.replace('data:image/jpeg;base64,',''))
    // }
    



 
  }, []);

  const profileImageSrc = image ? `data:image/jpeg;base64,${image}` : avatar1;


  const [loader, setLoader] = useState(false);

  useEffect(() => {
    const loginData = JSON.parse(localStorage.getItem('loginData'));
    setMemberType(loginData?.userType);
    setMemberName(loginData?.userName);
    const memberData = JSON.parse(localStorage.getItem('memberData'));
    if (memberData !== null && Object.keys(memberData).length > 0) {
      setMember((prev) => ({
        ...prev,
        name: memberData[0].membername,
        type: memberData[0].membertype
      }));
    }
  }, []);

  const [data, setData] = useState([]);
  const [memId, setMemid] = useState('');

  useEffect(() => {
    const token = localStorage.getItem('token');
    const memberId = localStorage.getItem('memberId');
    setMemid(memberId);
    const userType = localStorage.getItem('usertype');

    if (userType === 'Member') {
      getdata(token,memberId);
    }
  }, []);
  const getdata = async (token,id) => {
    const h = {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json'
    };
    try {
      const params = `?MemberID=${id}`;
      const { data } = await axios.get(`${window.BASE}${window.NOTIFICATION_GET}${params}`, { headers: h });
      setData(data);
      dispatch({ type: 'Notification', notify: count(data) });
    } catch (error) {}
  };

  const count = (notifications) => {
    const c = notifications.filter((notification) => notification.read == 0);
    return c.length;
  };
  const handleLogout = async () => {
    localStorage.setItem('key', 'false');
    localStorage.clear();
    navigate('/auth/signin-1');
    window.location.reload();
    dispatch({type:"type",payload:"login"})
  };

  const handleProfile = () => {
    navigate('/myprofile');
    window.location.reload();
  };

  const changePassword = () => {
    navigate('/changepassword');
    window.location.reload();
  };

  const handleChat = () => {
    navigate('/chat-page');
  };

  const getProfileimg =async (tok,id)=>{
    setLoader(false);
    const h = {
      Authorization: `Bearer ${tok}`,
      'Content-Type': 'application/json'
    };
    try{
      setLoader(true)
      const {data} = await axios.get(`${window.BASE}${window.GETUSERPROFILEIMG}/${id}`, { headers: h })
      
        setimg(data.photo)

      
      // else{
      //   setimg(avatar1)
      // }

      setLoader(false)
    }
    catch{
      setLoader(false)
    }

  }

  
  return (
    <>
      {isWidth ? (
        <React.Fragment>
          <ListGroup as="ul" bsPrefix=" " className="navbar-nav ml-auto">
            {memberType === 'Member' && (
              <>
                <ListGroup.Item as="li" bsPrefix=" " className="list-style">
                  <div style={{ marginRight: '70px', marginTop: '8px', cursor: 'pointer' }} className="mob-toggler notification-icon">
                    <i
                      className="fa-solid fa-bell"
                      style={{ width: '29px', height: '29px', color: 'white' }}
                      onClick={() => handleChat()}
                    />
                    {state?.notification > 0 &&  <div class="mob-count-child">{state?.notification}</div>}
                   
                  </div>
                </ListGroup.Item>
              </>
            )}

            <ListGroup.Item as="li" bsPrefix=" " className="list-style">
              <span>{member?.name}</span>
              <span>{member?.type}</span>
            </ListGroup.Item>
            <ListGroup.Item as="li" bsPrefix=" ">
              <Dropdown align={!rtlLayout ? 'end' : 'start'} className="drp-user" show={dropdownVisible}>
                <Dropdown.Toggle as={Link} variant="link" to="#" id="dropdown-basic" onClick={handleImageClick}>
                  <img src={ profileImageSrc } className="img-radius wid-40" alt="User Profile" />
                </Dropdown.Toggle>
                <Dropdown.Menu align="end" className="profile-notification">
                  <div className="pro-head">
                  <img src={ profileImageSrc } className="img-radius wid-40" alt="User Profile" />
                    <span>{membername}</span>
                  </div>
                  <ListGroup as="ul" bsPrefix=" " variant="flush" className="pro-body">
                    {memberType === 'Admin' ? null : (
                      <>
                        <ListGroup.Item as="li" bsPrefix=" ">
                          <Link className="dropdown-item" onClick={handleProfile}>
                            <i className="feather icon-user" /> Profile
                          </Link>
                        </ListGroup.Item>
                      </>
                    )}
                    <ListGroup.Item as="li" bsPrefix=" ">
                      <Link to="#" className="dropdown-item" onClick={changePassword}>
                        <i className="feather icon-lock" /> Change Password
                      </Link>
                    </ListGroup.Item>
                    <ListGroup.Item as="li" bsPrefix=" ">
                      <Link className="dropdown-item" onClick={handleLogout}>
                        <i className="feather icon-log-out" /> Logout
                      </Link>
                    </ListGroup.Item>
                  </ListGroup>
                </Dropdown.Menu>
              </Dropdown>
            </ListGroup.Item>
          </ListGroup>
        </React.Fragment>
      ) : (
        <React.Fragment>
          <ListGroup as="ul" bsPrefix=" " className="navbar-nav ml-auto">
            <ListGroup.Item as="li" bsPrefix=" ">
              <Dropdown align={!rtlLayout ? 'end' : 'start'} className="drp-user" show={dropdownVisible}>
                <Dropdown.Menu align="end" className="profile-notification mb-style-drop" style={{ position: 'fixed' }}>
                  <div className="pro-head">
                    <img src={ profileImageSrc} className="img-radius" alt="User Profile" />
                    <span>{membername}</span>
                  </div>
                  <ListGroup as="ul" bsPrefix=" " variant="flush" className="pro-body">
                    {memberType === 'Admin' ? null : (
                      <>
                        <ListGroup.Item as="li" bsPrefix=" ">
                          <Link className="dropdown-item" onClick={handleProfile}>
                            <i className="feather icon-user" /> Profile
                          </Link>
                        </ListGroup.Item>
                      </>
                    )}
                    <ListGroup.Item as="li" bsPrefix=" ">
                      <Link to="#" className="dropdown-item" onClick={changePassword}>
                        <i className="feather icon-lock" /> Change Password
                      </Link>
                    </ListGroup.Item>
                    <ListGroup.Item as="li" bsPrefix=" ">
                      <Link className="dropdown-item" onClick={handleLogout}>
                        <i className="feather icon-log-out" /> Logout
                      </Link>
                    </ListGroup.Item>
                  </ListGroup>
                </Dropdown.Menu>
              </Dropdown>
            </ListGroup.Item>
          </ListGroup>
        </React.Fragment>
      )}
    </>
  );
};

export default NavRight;
